import {setConfirmInfo} from '@/stores/ui-store';
import {uniqueId} from '@/lib/utils';

export type ConfirmInfo<P = undefined> = {
  id?: string;
  message?: string;
  title?: string;
  payload?: P;
  onConfirm?: (payload: P) => (void | boolean | Promise<any>);
  onShow?: (payload: P) => Partial<ConfirmInfo<P>>;
}

export const validateConfirmInfo = (info: ConfirmInfo | null) => {
  if (info != null) {
    if (!info.message) {
      info.message = 'Are you sure you want to proceed?';
    }
    if (!info.title) {
      info.title = 'Please Confirm';
    }
    if (!info.onConfirm) {
      throw new Error('onConfirm callback is required for confirm info');
    }
  }
  return info;
}

export function useConfirmOnClick<P = undefined>(props: ConfirmInfo<P>) {
  return (payload: P | any = undefined) => {
    const isClick = payload && payload.type && payload.type === 'click';
    let _props = {...props};
    if (!_props.id) {
      props.id = uniqueId('confirm_');
    }
    if (payload && !isClick) {
      _props.payload = payload;
    }
    if (_props.onConfirm) {
      if (_props.onShow) {
        const updated = _props.onShow(payload);
        if (updated) {
          _props = {..._props, ...updated};
        }
      }
      setConfirmInfo(_props as any);
    }
  };
}